import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { SALENG_SHOP_API_PROD } from "./../config";

const SALENG_SHOP_API = SALENG_SHOP_API_PROD;

const getAccessToken = () => localStorage.getItem("accessToken") || null;

const decodeToken = () => {
  const token = getAccessToken();
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

const getIds = () => {
  const decoded = decodeToken();
  return {
    accessToken: getAccessToken(),
    userId: decoded?.id ?? null,
    shopId: decoded?.shopId ?? null,
    branchId: decoded?.branchId ?? null,
    isMain: decoded?.isMain ?? false,
  };
};

export const createCustomer = (payload) => {
  const { shopId, branchId } = getIds();

  return axios.post(
    `${SALENG_SHOP_API}/customer`,
    { ...payload, shopId: shopId, branchId: branchId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const updateCustomer = (payload, id) => {
  const { shopId, branchId } = getIds();

  return axios.patch(
    `${SALENG_SHOP_API}/customer/${id}`,
    { ...payload, shopId: shopId, branchId: branchId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const upload = (formData) => {
  return axios.post(`${SALENG_SHOP_API}/files`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getCustomers = (customerType) => {
  const { shopId, branchId } = getIds();

  return axios.get(
    `${SALENG_SHOP_API}/customer`,
    {
      params: {
        shopId,
        branchId,
        customerType,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const getCustomersList = () => {
  const { shopId, branchId } = getIds();

  return axios.get(
    `${SALENG_SHOP_API}/customer/list`,
    {
      params: {
        shopId: shopId,
        branchId: branchId,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const getCustomersById = (id) => {
  return axios.get(
    `${SALENG_SHOP_API}/customer/${id}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const getGroup = () => {
  const { shopId, branchId } = getIds();

  return axios.get(
    `${SALENG_SHOP_API}/customer/groups`,
    {
      params: {
        shopId: shopId,
        branchId: branchId,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const addGroup = (payload) => {
  const { shopId, branchId } = getIds();

  return axios.post(
    `${SALENG_SHOP_API}/customer/group`,
    { ...payload, shopId: shopId, branchId: branchId },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const getCustomerByGroup = (id) => {
  return axios.get(
    `${SALENG_SHOP_API}/customer/groups/${id}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const addCustomerToGroup = (payload) => {
  return axios.post(
    `${SALENG_SHOP_API}/customer/group/add-customer`,
    { ...payload },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const updateCustomeGroup = (payload) => {
  return axios.post(
    `${SALENG_SHOP_API}/customer/group/remove-customer`,
    { ...payload },
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};
export const addCustomeFarmer = (payload) => {
  return axios.post(`${SALENG_SHOP_API}/customer/farmers`, payload, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};
export const editCustomeFarmer = (payload, farmer_id) => {
  return axios.put(
    `${SALENG_SHOP_API}/customer/farmers/${farmer_id}`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};
export const getCustomeFarmerByID = (farmer_id) => {
  return axios.get(`${SALENG_SHOP_API}/customer/farmers/${farmer_id}`, {
    headers: {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer ' + token
    },
  });
};
export const getCustomeFarmerByCustomerID = (customer_id) => {
  return axios.get(
    `${SALENG_SHOP_API}/customer/farmers/by-customer/${customer_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        // 'Authorization': 'Bearer ' + token
      },
    },
  );
};

export const uploadFile = (formData, type) => {
  return axios.post(`${SALENG_SHOP_API}/files/farmers/${type}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const generateQrcode = (amount) => {
  return axios.post(
    `${SALENG_SHOP_API}/transaction/generate-qrcode`,
    { amount },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const getQrcode = (uuid) => {
  return axios.get(`${SALENG_SHOP_API}/transaction/qrcode`, {
    params: {
      uuid: uuid || undefined,
    },
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const markPrinted = (uids) => {
  return axios.post(
    `${SALENG_SHOP_API}/transaction/qrcode/mark-printed`,
    { uids },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const saveFarmerFile = (payload) => {
  return axios.post(`${SALENG_SHOP_API}/customer/farmers/files`, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getFarmerFiles = (farmerId, type) => {
  return axios.get(`${SALENG_SHOP_API}/customer/farmers/files/${farmerId}`, {
    params: { type },
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const deleteFarmerFile = (id) => {
  return axios.delete(`${SALENG_SHOP_API}/customer/farmers/files/${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getBagsByQrs = (uids = []) => {
  return axios.post(
    `${SALENG_SHOP_API}/transaction/qrcode/bags`,
    { uids },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

export const saveBagsForQr = (uid, bags = []) => {
  return axios.post(
    `${SALENG_SHOP_API}/transaction/${uid}/bags`,
    { bags },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
